class ConceptoLiquidacion {
  constructor(idConcepto,descripcion){
    this.idConcepto=idConcepto
    this.descripcion=descripcion
  }
} 

export default ConceptoLiquidacion
